import React, { useMemo } from 'react';
import styled from 'styled-components';
import { SponsoredProduct } from 'config/markets/types';
import DataContainer from 'src/components/data';
import { ProductGridCard } from 'src/components/product-card-new';
import { SponsoredProductQuery } from 'src/types';
import sponsoredProductQuery from './sponsored-product-query.graphql';
import { SponsoredProductLoader } from './loader';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

const SponsoredProductCard = (props: SponsoredProductQuery) => {
  const { product } = props;
  return product ? (
    <ProductGridCard
      brand={product.brand}
      imageSrc={product.media?.first || ''}
      shouldLazyLoadImage
      link={product.pathName}
      name={product.name}
      onClick={() =>
        trackInternalNavigationClick({
          scope: InternalNavigationScope.SPONSORED_PRODUCT,
          nextPage: product.pathName,
        })
      }
      price={product.priceSummary.regular}
      rating={
        product.aggregatedRatingSummary?.summary.rating.score ||
        product.userReviewSummary?.rating
      }
      reviewsCount={
        product.aggregatedRatingSummary?.summary.rating.count ||
        product.userReviewSummary?.count
      }
      properties={product.properties?.nodes}
      selectable={false}
      isSponsored
    />
  ) : null;
};

const renderLoader = () => <SponsoredProductLoader />;
const renderError = () => null;
const renderComponent = ({ data }: { data: SponsoredProductQuery }) => (
  <SponsoredProductCard product={data.product} />
);

export const SponsoredProducts = ({
  productIds,
  sponsoredProducts,
}: {
  productIds: number[];
  sponsoredProducts: SponsoredProduct[];
}) => {
  const { productId, backupProductId } = sponsoredProducts[0] || {};
  const NUM_PRODUCTS_ABOVE_THE_FOLD = 8;
  const variables = useMemo(
    () => ({
      productId: productIds
        .slice(0, NUM_PRODUCTS_ABOVE_THE_FOLD)
        .includes(productId)
        ? backupProductId
        : productId,
    }),
    [productIds, productId, backupProductId]
  );
  return sponsoredProducts.length ? (
    <SponsoredProductWrapper key={`sponsored-product-${variables.productId}`}>
      <DataContainer
        variables={variables}
        query={sponsoredProductQuery}
        renderLoader={renderLoader}
        renderError={renderError}
        render={renderComponent}
      />
    </SponsoredProductWrapper>
  ) : null;
};

const SponsoredProductWrapper = styled.div`
  order: 3;
`;
